module.exports = __webpack_public_path__ + "img/chuanzhibanner.6bee18df.png";